import { IPublicClientApplication } from '@azure/msal-browser';
import { dvList, dvCreate, dvUpdate, dvDelete } from '../api/dataverseClient';
import { PunchItem } from '../types';

const FIELDS = [
  'dagrun_pm_punchitemid', 'dagrun_pm_name', 'dagrun_pm_description',
  'dagrun_pm_location', 'dagrun_pm_trade',
  'dagrun_pm_assigneeid', 'dagrun_pm_assigneename',
  'dagrun_pm_status', 'dagrun_pm_severity', 'dagrun_pm_duedate',
  'dagrun_pm_notes', 'dagrun_pm_projectid',
  'dagrun_pm_drawingreference', 'dagrun_pm_verifiedby', 'dagrun_pm_verifiedon',
  'dagrun_pm_itemnumber', 'dagrun_pm_photosjson',
  'createdon',
];

export async function getProjectPunchItems(pca: IPublicClientApplication, projectId: string): Promise<PunchItem[]> {
  return dvList<PunchItem>(pca, 'dagrun_pm_punchitems', {
    select: FIELDS,
    filter: `dagrun_pm_projectid eq '${projectId}'`,
    orderby: 'dagrun_pm_itemnumber asc,createdon asc',
    top: 1000,
  });
}

export interface CreatePunchInput {
  projectId: string;
  name: string;
  description?: string | null;
  location?: string | null;
  trade?: string | null;
  drawingreference?: string | null;
  assigneeid?: string | null;
  assigneename?: string | null;
  duedate?: string | null;
  severity?: number;
  status?: number;
  notes?: string | null;
  verifiedby?: string | null;
  verifiedon?: string | null;
  itemnumber?: number | null;
}

export async function createPunchItem(pca: IPublicClientApplication, input: CreatePunchInput): Promise<string> {
  const body: Record<string, unknown> = {
    dagrun_pm_name: input.name,
    dagrun_pm_projectid: input.projectId,
    dagrun_pm_severity: input.severity ?? 1, // Minor
    dagrun_pm_status:   input.status ?? 1,    // Open
  };
  if (input.description)      body.dagrun_pm_description = input.description;
  if (input.location)         body.dagrun_pm_location = input.location;
  if (input.trade)            body.dagrun_pm_trade = input.trade;
  if (input.drawingreference) body.dagrun_pm_drawingreference = input.drawingreference;
  if (input.assigneeid)       body.dagrun_pm_assigneeid = input.assigneeid;
  if (input.assigneename)     body.dagrun_pm_assigneename = input.assigneename;
  if (input.duedate)          body.dagrun_pm_duedate = input.duedate;
  if (input.notes)            body.dagrun_pm_notes = input.notes;
  if (input.verifiedby)       body.dagrun_pm_verifiedby = input.verifiedby;
  if (input.verifiedon)       body.dagrun_pm_verifiedon = input.verifiedon;
  if (input.itemnumber != null) body.dagrun_pm_itemnumber = input.itemnumber;
  return dvCreate(pca, 'dagrun_pm_punchitems', body);
}

export async function updatePunchItem(pca: IPublicClientApplication, id: string, patch: Record<string, unknown>): Promise<void> {
  return dvUpdate(pca, 'dagrun_pm_punchitems', id, patch);
}

export async function deletePunchItem(pca: IPublicClientApplication, id: string): Promise<void> {
  return dvDelete(pca, 'dagrun_pm_punchitems', id);
}

/**
 * Next sequential item number for a project = (current max itemnumber) + 1.
 * Items with a null itemnumber (legacy rows) are treated as 0.
 */
export function nextItemNumber(items: PunchItem[]): number {
  const max = items.reduce((m, i) => Math.max(m, i.dagrun_pm_itemnumber ?? 0), 0);
  return max + 1;
}
